// 🔴 Bloc Visites de la fiche artisan — le RELEVÉ DE TRAVAUX du moteur `chantier/`.
//
// ⚠️ Ce fichier était un EMPLACEMENT (L2) : `chantier/` n'exposait alors aucune
// route. Il monte désormais le relevé (pages/chantier/ReleveChantier), qui
// n'appelle QUE `/api/chantier/*`.
// 🔑 Le profil de relevé est celui DÉCLARÉ par le tenant
// (`tenants.config.profil_chantier`) — ⛔ jamais deviné, ⛔ aucun slug.
// ⛔ Aucun repli sur le DAL gelé (`EnvoyerVisiteBlock`, `VisitesDuDossier`,
// `/api/visite/*`) — vérifié par `garde_frontiere_artisan.test.js`.
// 🔴 N°975 — sous un relevé consulté, « Créer le devis » (pont serveur existant),
//    INJECTÉ ici : le devis créé s'ouvre dans la vue document de la fiche.
import { profilChantier } from "../../../utils/tenantProfile";
import { ReleveChantier } from "../../chantier/ReleveChantier";
import { CreerDevisReleve } from "./CreerDevisReleve";

export function EmplacementVisites({ dossierId, onNavigate }) {
  const ouvrir = onNavigate
    ? (d) => onNavigate("devis-document", { devisId: d.devis_id, dossierId, from: "dossier" })
    : undefined;
  return (
    <div data-testid="artisan-visites" style={{ display: "grid", gap: 8 }}>
      <div style={{ fontWeight: 500, color: "var(--oh-text)" }}>Visites</div>
      {dossierId
        ? <ReleveChantier dossierId={dossierId} profilCode={profilChantier()}
                          actionsReleve={(r) => <CreerDevisReleve releve={r} onOuvrir={ouvrir} />} />
        : <p className="text-sm" style={{ color: "var(--oh-text-muted)" }}>Dossier non identifié.</p>}
    </div>
  );
}

export default EmplacementVisites;
